import { Component, HostBinding, Input, OnInit } from '@angular/core';

/**
 * Shows a loading spinner while loading. If the loading attribute is false, the content is displayed.
 *
 * The loading spinner will always be centered.
 * This means you the min-height style can be used to set the size of the loading-spinner to a value that is close
 * to the size of the final content (prevents sudden jumps caused by size changes on the website if content is loaded).
 *
 * Example:
 * ```html
 * <app-loading-spinner [loading]="loading">
 *   Some content that is displayed if loading is false.
 *   If loading is true, the spinner is displayed.
 * </app-loading-spinner>
 * ```
 */
@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  /**
   * If true, the spinner is displayed instead of the content
   */
  @Input() @HostBinding('class.spinner-loading') loading = false;

  constructor() { }

  ngOnInit(): void {
  }

}
